export const SERVICES = [
  {
    id: "monthly-bookkeeping",
    name: "Monthly Bookkeeping",
    blurb:
      "Clean, current books every single month — so you always know exactly where your business stands.",
    included: [
      "Transaction categorization",
      "Bank & credit reconciliations",
      "Journal entries",
      "General ledger maintenance",
      "Accounts payable / receivable management",
      "Month-end close",
      "Year-end coordination with CPA / tax preparer",
    ],
    excluded: ["Bill payment authorization", "Check signing", "Cash handling"],
  },
  {
    id: "financial-reporting",
    name: "Financial Reporting",
    blurb:
      "Reports you can actually read — delivered with a walking-you-through-it review, not just an attachment.",
    included: [
      "Balance sheet",
      "Profit & loss",
      "Statement of cash flows",
      "Management reporting",
      "Financial review meeting (monthly or quarterly)",
    ],
    excluded: ["Audits", "CPA review", "Compilations", "Investment advice"],
  },
  {
    id: "payroll-oversight",
    name: "Payroll Oversight",
    blurb:
      "A second set of expert eyes on every payroll run — catching errors before they become penalties.",
    included: [
      "Payroll register review",
      "Payroll journal entry review",
      "Monthly payroll reconciliations",
      "Coordination with payroll provider",
      "Payroll reporting analysis",
      "Bonus and incentive calculation review",
      "Process improvement recommendations",
      "941 & 941X review",
      "Payroll liabilities review",
    ],
    excluded: [
      "Payroll processing",
      "Payroll tax filings",
      "Tax deposits",
      "W-2 preparation",
      "Employment tax registration",
      "New hire reporting",
      "Garnishment administration",
      "Worker's compensation administration",
      "Benefits / timekeeping administration",
    ],
  },
  {
    id: "compensation-incentives",
    name: "Compensation & Incentives Consulting",
    blurb:
      "Salary-based bonus and incentive programs designed to reward performance and support your business goals.",
    included: [
      "Design bonus and sales incentive programs that supplement an employee's base salary",
      "Document compensation policies",
      "Administration of bonus and sales incentive programs",
      "Analyze compensation costs",
      "Model incentive payouts",
      "Improve payroll controls",
    ],
    excluded: ["Commission-based compensation arrangements, including draw-against-commission plans"],
  },
  {
    id: "business-advisory",
    name: "Business Advisory Services",
    blurb:
      "Strategic, numbers-first guidance for the decisions that shape your next chapter.",
    included: [
      "QuickBooks setup & cleanup",
      "Catch-up bookkeeping",
      "Cash flow forecasting",
      "Financial reporting for tax preparation",
      "Budget development",
      "Accounting and internal control recommendations",
    ],
    excluded: [
      "Income tax filings",
      "Legal advice",
      "Tax advice",
      "Business valuations",
      "HR consulting",
    ],
  },
  {
    id: "special-projects",
    name: "Special Projects",
    blurb:
      "Focused, one-time engagements that untangle the past and set your systems up for the future.",
    included: [
      "QuickBooks cleanup",
      "Historical bookkeeping cleanup",
      "New business accounting setup",
      "Chart of accounts redesign",
      "Accounting process documentation",
      "ERP implementation assistance",
      "Financial reporting redesign",
    ],
    excluded: [],
  },
];

export const TIME_SLOTS = [
  "Morning (9:00 AM – 12:00 PM)",
  "Midday (12:00 – 2:00 PM)",
  "Afternoon (2:00 – 5:00 PM)",
];

export const DISCLAIMER =
  "Rooted Business Advisors, LLC provides bookkeeping, financial reporting, payroll oversight, compensation consulting, and business advisory services. Rooted is not a CPA firm, law firm, tax advisor, investment adviser, or broker-dealer and does not provide legal, tax, investment, audit, attestation, or assurance services.";

export const CONTACT = {
  phoneDisplay: "(513) 288-8842",
  phoneHref: "tel:+15132888842",
  email: "Jennifer@RootedBusinessAdvisors.com",
};
